<template>
  <div class="container-busca">
    
    <div class="row">
        <div class="col-sm-12">
      <h2 class="d-none d-sm-block">Gerenciamento de Leads</h2>
      <h4 class="d-block d-sm-none">Gerenciamento de Leads</h4><br>
    </div>

      <router-link v-if="getPermissao() == 1" to="/lead" class="col-sm-3  btn btn-warning d-none d-sm-block">+ Cadastrar Novo Lead</router-link> 
<!--<a target="_blank" :href="'https://www2.royaljardim.com.br/sistema/leads/exportacao'" v-if="getPermissao() == 1" class="col-sm-3  btn btn-warning d-none d-sm-block ml-3">IMPORTAR LEADS</a> -->
<button type="button" class="btn btn-secondary btn-sm ml-5" @click="buscaRapida">Aguardando atendimento</button>
      <div class="col-sm-12"><br></div>




<form class="row" method="POST" ref="formulario" @submit.prevent.stop="buscar">
    <div class="form-group col-sm-12 form-check ml-3">
           <input type="checkbox" name="ocultar" value="Sim" v-model="ocultar" checked class="form-check-input" id="exampleCheck1">
           <label class="form-check-label" for="exampleCheck1"  >Ocultar arquivados</label>
        
        </div>


  <div class="form-group col-sm-3">
          <label>Data:</label>
             <Datepicker @reset="resetarData" show-clear-button placeholder="De - Até" range v-model="selectedDate" lang="pt-br" date-format="formato"/>
        </div>
  

 <div class="form-group col-sm-2 d-none d-sm-block">
        <label>Status:</label>
        
        <select class="form-control" name="status" v-model="status">
           <option value="">Selecione</option>
        <option value="Pendente">Aguardando Atendimento</option>
            <option value="Em Atendimento">Reunindo Informações</option>
            <option value="Pouca chance">Procurando imóvel sem dinheiro</option>
             <option value="Média Chance">Procurando imóvel com permuta</option>
              <option value="Cliente hot">Procurando imóvel com dinheiro</option>
               <option value="Arquivado Vendido">Arquivado Vendido</option>
               <option value="Arquivado Não Vendido">Arquivado Não Vendido</option>
       <option value="Dificil Contato">Dificil Contato</option>
                  <option value="Duplicidade">Duplicidade</option>
    </select>
  </div>

          <div class="form-group col-sm-3">
          <label>Nome:</label>
          <input type="text" name="nome" class="form-control" value="" v-model="nome">
        </div>

       


         <div class="form-group col-sm-2 d-none d-sm-block">
          <label>Valor de:</label>
          <input type="text" name="valor" class="form-control" v-money="money" v-model.lazy="valor" />
        </div>

        <div class="form-group col-sm-2 d-none d-sm-block">
          <label>Até:</label>
          <input type="text" name="valor2" class="form-control" v-money="money" v-model.lazy="valor2" />
        </div>
  

         <div class="form-group col-sm-2 d-none d-sm-block">
          <label>Metragem de:</label>
          <input type="text" name="metragem" class="form-control"  v-model="metragem" />
        </div>

        <div class="form-group col-sm-2 d-none d-sm-block">
          <label>Até:</label>
           <input type="text" name="metragem2" class="form-control"  v-model="metragem2" />
        </div>

         <div class="form-group col-sm-2 d-none d-sm-block">
          <label>Fonte:</label>
           <input type="text" name="fonte" class="form-control"  v-model="fonte" />
        </div>

         <div class="form-group col-sm-2 d-none d-sm-block">
          <label>Telefone:</label>
           <input type="text" name="telefone" class="form-control"  v-model="telefone" />
        </div>
  
  <div class="form-group col-sm-4 d-none d-sm-block">
          <label>Região:</label>
    <AutocompleteRegiao ref="autocomplete" :resultados.sync="matches" :nome.sync="bairroSelecionado" @pronto="addBairro" url="autocompleteBairros" classe="autocompleteEdificios"></AutocompleteRegiao>
</div>

<div class="form-group col-sm-4">
          <label>Edificio:</label>
          <AutocompleteCustom ref="autocomplete" :resultados.sync="matchesEdificio" :nome.sync="edificioSelecionado" @pronto="addEdificio" url="autocompleteEdificios" classe="autocompleteEdificios"></AutocompleteCustom>
          
        </div>

<div class="form-group col-sm-4">
  <label>Corretor:</label>
         <select v-if="getPermissao() == '1' || getUsuario() == 'Royal Jardim'" class="form-control"  name="corretor" style="" v-model="corretor" >
            <option value="">Selecione</option>
            <option v-for="user in usuarios" :key="user.LOG_ID" :value="user.LOG_ID">{{user.LOG_NOME}}</option>
            </select>
</div>

          <button ref="buscar" type="submit" class="btn btn-warning col-sm" style="max-height:40px;margin-top:30px;">BUSCAR</button>
           <button  class="btn btn-danger col-sm ml-1" @click="limpar" type="button"  style="max-height:40px;margin-top:30px;">LIMPAR</button>

       </form>

    </div><!-- row -->

    <div class="row">
   <div class="col-12"><br>
     <img src="/img/flags.jpeg" clas="img-fluid d-block mx-auto"/><br><br>
  </div><!-- col -->
</div><!-- row -->


    <div class="row">

       <div class="col-sm-2" v-if="loading" >
          <div class="spinner-border" role="status" style="max-height:40px;margin-top:35px;">
            <span class="sr-only">Loading...</span>
          </div>
        </div>

<br>

<div class="">
 <table class="col-sm table  ">
  <thead>
    <tr>
      <th scope="col">Fonte</th>
       <th scope="col">Entrada</th>
       <th scope="col">Atualização</th>
      <th scope="col">Nome</th>
      <th scope="col">Edificio</th>
      <th scope="col">Status</th>
      <th scope="col"></th>
       <th width="" scope="col">Valor</th>
         <th scope="col">M<sup>2</sup></th>
          
        <th scope="col">Corretor</th>
        <th scope="col"></th>
       <th scope="col"></th>
        <th scope="col"></th> 
    </tr>
  </thead>
  <tbody>
    <tr v-for="item in leads" :key="item.LD_ID" :class="{'destacado':item.LD_AGENDADO == 2,'pink-background':item.TARJA == 2,'red-background':item.TARJA == 3}" >
     
      <td >{{item.LD_REFERENCIA}}</td>
       <td >{{item.LD_DATA}}</td>
      <td >{{item.LD_ATUALIZACAO}}</td>
      <td >{{item.LD_NOME}}</td>
      <td>{{item.ED_NOME}}</td>
      <td >
         <img src="/img/flag_pendente.png" class="img-fluid " v-if="item.LD_STATUS == 'Pendente'" width="30" height="30"/>
       <img src="/img/flag_atendimento.png" class="img-fluid " v-if="item.LD_STATUS == 'Em Atendimento'" width="30" height="30"/>
       <img src="/img/flag_mediachance.png" class="img-fluid " v-if="item.LD_STATUS == 'Média Chance'" width="30" height="30"/>
       <img src="/img/flag_poucachance.png" class="img-fluid " v-if="item.LD_STATUS == 'Pouca chance'" width="30" height="30"/>
       <img src="/img/flag_hot.png" class="img-fluid " v-if="item.LD_STATUS == 'Cliente hot'" width="30" height="30"/>
       <img src="/img/flag_vendido.png" class="img-fluid " v-if="item.LD_STATUS == 'Arquivado Vendido'" width="30" height="30"/>
       <img src="/img/flag_naovendido.png" class="img-fluid " v-if="item.LD_STATUS == 'Arquivado Não Vendido'" width="30" height="30"/>
       <img src="/img/flag_naovendido.png" class="img-fluid " v-if="item.LD_STATUS == 'Dificil Contato'" width="30" height="30"/>
       <img src="/img/flag_naovendido.png" class="img-fluid " v-if="item.LD_STATUS == 'Duplicidade'" width="30" height="30"/>
      </td>
       <td >
            <select class="form-control combo-status" ref="comboStatus" name="status" style="width:150px;" v-model="item.LD_STATUS" @change="trocarStatus(item.LD_ID,$event)">
            <option value="">Selecione</option>
            <option value="Pendente">Aguardando Atendimento</option>
            <option value="Em Atendimento">Reunindo Informações</option>
            <option value="Pouca chance">Sem dinheiro</option>
             <option value="Média Chance">Com dinheiro parcial</option>
              <option value="Cliente hot">Com dinheiro</option>
               <option value="Arquivado Vendido">Arquivado Vendido</option>
               <option value="Arquivado Não Vendido">Arquivado Não Vendido</option>
                 <option value="Dificil Contato">Dificil Contato</option>
                  <option value="Duplicidade">Duplicidade</option>
            </select>
       </td>
       <td ><input style="max-width:130px" type="text" readonly v-money="money" :value="item.LD_VALOR" /></td>
        
         <td >{{item.LD_METRAGEM}}</td>
       
     <!-- <td >{{item.LOG_NOME}}</td> -->
       <td >
         
         
            <select v-if="getPermissao() == '1' || getUsuario() == 'Royal Jardim'" class="form-control combo-corretores" ref="comboCorretores" name="corretor" style="width:150px;" v-model="item.LOG_ID" @change="trocarCorretor(item.LD_ID,$event)">
            <option value="">Selecione</option>
            <option v-for="user in usuarios" :key="user.LOG_ID" :value="user.LOG_ID">{{user.LOG_NOME}}</option>
            </select>
        
       </td>

       <td><a  target="_blank" :href="'https://api.whatsapp.com/send?phone=55' + item.LD_TELEFONE"><img src="/img/bt_whatsApp.png" style="width:30px;height:30px;" class="" /></a></td>
      <td>
        <popper @show="getHistorico(item.LD_ID)" 
        trigger="hover"
        :options="{
          placement: 'left',
          modifiers: { offset: { offset: '0,10px' } }
        }">
        <router-link :to="'/lead/'+item.LD_ID" class="btn btn-sm btn-info" slot="reference">Ver</router-link> 
    
    <div class="popper" style="width:580px;background:#F4E7B2;">
     
      <img style="width:150px;height:auto;display:inline-block;float:left" :src="'https://www2.royaljardim.com.br/sistema/fotos/'+item.LD_FOTO"  />
      <div class="d-flex flex-column pl-2" style="float:left;max-width:390px;">
       <h5 class=""><strong>{{item.LD_NOME}}</strong></h5>
        <p class=""><strong>Obs:</strong> <i>{{item.LD_OBS}}</i></p>
      <p :id="'pop'+item.LD_ID">...</p>
      </div>
    </div>
 
  </popper>
      </td>
       <td>
         <div class="text-black " style="background:#a3edc9;" v-if="item.TARJA == 1"><small class="px-2 d-block mx-auto text-center"><i>{{ item.DIAS}} Dia(s)</i></small></div>
         <div class="text-black " style="background:#ea93a0;" v-if="item.TARJA == 2"><small class="px-2 d-block mx-auto text-center"><i>{{ item.DIAS}} Dia(s)</i></small></div>
         <div class="text-black " style="background:red;color:#FFF" v-if="item.TARJA == 3"><small class="px-2 d-block mx-auto text-center"><i>{{ item.DIAS}} Dia(s)</i></small></div></td> 

     

    </tr>
   
  </tbody>
</table>
</div>
<div class="col-sm-4 offset-sm-4">
   <div  v-if="loading" >
          <div class="spinner-border" role="status" style="max-height:40px;margin-top:15px;">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
 <button @click="paginar" ref="paginar" type="submit" class="btn btn-warning col-sm" style="max-height:40px;margin-top:10px;">MAIS RESULTADOS</button>
       
 </div>
    </div><!-- row table -->



  </div>
</template>
<style>
.destacado{background:#ffff77 !important;}
.pink-background{background:pink !important;}
.red-background{background:#ea93a0 !important;}
table{font-size:.9em;}
</style>
<script>
import axios from 'axios'
import AutocompleteRegiao from '@/components/AutocompleteRegiao'
import AutocompleteCustom from '@/components/AutocompleteCustom'
import Popper from 'vue-popperjs';
import 'vue-popperjs/dist/vue-popper.css';

export default {
  name: 'BuscaLeads',
  components: {AutocompleteRegiao,AutocompleteCustom,Popper},
  
  data(){
      return {
        corretor:'',
         usuarios:[],
         selectedEdificio:null,
        edificioSelecionado:'',
             matchesEdificio:[],
        ocultar:true,
        fonte:'',
        telefone:'',
        bairroSelecionado:'',
        selectedBairro:'',
         matches:[],
        metragem:null,
        metragem2:null,
        formato:{day: '2-digit',month: '2-digit',year: 'numeric' },
        selectedDate:[],
        referencia:'',
        status:'',
       nome:'',
          leads:[],
          loading: false,
          valor:'',
          valor2:'',
          
          money: {
            decimal: ',',
            thousands: '.',
            prefix: 'R$ ',
            suffix: '',
            precision: 2,
            masked: false,
            
             
          }
      }
  },
 

methods:{
  buscaRapida(){
    this.status = "Pendente";
    const elem = this.$refs.buscar;
    elem.click();
   
  },
    trocarStatus(id,event){
   
      let fm = new FormData();
      fm.append('id',id);
      fm.append('status',event.target.value);
      this.loading = true;
          axios
          .post('https://www2.royaljardim.com.br/sistema/leads/trocarStatus',fm)
          .then(response => console.log(response))
          .catch(response => console.log(response))
          .finally(() =>  this.loading = false)
  },
  trocarCorretor(id,event){
   
      let fm = new FormData();
      fm.append('id',id);
      fm.append('corretor',event.target.value);
      this.loading = true;
          axios
          .post('https://www2.royaljardim.com.br/sistema/leads/trocarCorretor',fm)
          .then(response => console.log(response))
          .catch(response => console.log(response))
          .finally(() =>  this.loading = false)
  },
    getUsuarios(){
          this.loading = true;
          axios
          .post('https://www2.royaljardim.com.br/sistema/welcome/getUsuarios',{})
          .then(response => this.usuarios = response.data)
          .catch(response => console.log(response))
          .finally(() =>  this.loading = false)
    },
  copiarTelefone(data){
    let telefones = [];
   
      data.forEach(tel => { if(tel.LD_TELEFONE.length > 5){
        telefones.push(tel.LD_TELEFONE);
      }});
    
   
       window.navigator.clipboard.writeText(telefones).then(() => {
        console.log('Content copied to clipboard');
        /* Resolved - text copied to clipboard successfully */
      },() => {
        console.error('Failed to copy');
        /* Rejected - text failed to copy to the clipboard */
      });
  },
  getHistorico(id){
     axios
          .post('https://www2.royaljardim.com.br/sistema/leads/getHistorico/'+id)
          .then(response => {
            if(response.data.length > 0)
              window.$('#pop'+id).text(response.data[0].HI_TEXTO)
            })
          .catch(response => console.log(response))
          
  },
  paginar(){
    this.loading = true;
          let fm = null;

          
            fm = new FormData(this.$refs["formulario"]);
            fm.append('valor',this.filtrar(this.valor));
            fm.append('valor2',this.filtrar(this.valor2));
            fm.append('permissao',this.getPermissao());
            fm.append('corretor',this.getUsuario());
             fm.append('bairro',this.selectedBairro);
             fm.append('edificio',this.selectedEdificio);
             fm.append('paginacao',this.leads.length);
             if(this.ocultar){
                fm.append('ocultar','Sim');
             }else{
                fm.append('ocultar','Nao');
             }
           
              

            if(this.selectedDate.length > 0){
              let dd = Number(this.selectedDate[0].getDate());
              let mm = Number(this.selectedDate[0].getMonth() + 1);
              if (dd < 10) dd = '0' + dd;
              if (mm < 10) mm = '0' + mm;
              let de = this.selectedDate[0].getFullYear() + "-" + mm + "-" + dd + " 00:00";

              let dd2 = Number(this.selectedDate[1].getDate());
              let mm2 = Number(this.selectedDate[1].getMonth() + 1);
              if (dd2 < 10) dd2 = '0' + dd2;
              if (mm2 < 10) mm2 = '0' + mm2;
              let ate = this.selectedDate[1].getFullYear() + "-" + mm2 + "-" + dd2 + " 23:59";

               fm.append('de',de);
               fm.append('ate',ate);
            }

        
          axios
          .post('https://www2.royaljardim.com.br/sistema/leads/buscaleads',fm)
          .then( response => {console.log(response); response.data.forEach( lead => this.leads.push(lead) );this.copiarTelefone(this.leads)})
          .catch(response => console.log(response))
          .finally(() =>  {this.loading = false;})
    
  },
   addEdificio(valor){
      this.selectedEdificio = valor.ED_ID;
     
    },
    getEdificio(){
          this.loading = true;
          axios
          .post('https://www2.royaljardim.com.br/sistema/welcome/getEdificio',{id:this.selectedEdificio})
          .then(response => {this.edificioSelecionado = response.data.ED_NOME;
           this.$refs.autocomplete.preencher(response.data.ED_NOME);})
          .catch(response => console.log(response))
          
    },
  addBairro(valor){
      this.selectedBairro = valor.BAI_ID;
      
    },
  resetarData(){
    this.selectedDate = [];
  },
  limpar(){
          this.valor = '',
           this.valor2 = '',
           this.referencia = '',
           this.status = ''
            this.nome = '';
             this.selectedBairro = '';
              this.selectedEdificio = null;
              this.selectedDate = [];
               this.metragem = '';
                this.metragem2 = '';
                 this.fonte = '';
                 this.telefone = '';
                  this.corretor = '';
  },
  salvarFiltros(){
    return {
         
          leads: this.leads,
          loading: this.loading,
          valor:this.valor,
          valor2: this.valor2,
         
           referencia:this.referencia,
            status:this.status,

    }
  },

    get(){
       let fm = new FormData();
       fm.append('permissao',this.getPermissao());
      fm.append('corretor',this.getUsuario());
        fm.append('paginacao',0);

          this.loading = true;
          axios
          .post('https://www2.royaljardim.com.br/sistema/leads/getLeads',fm)
          .then(response => {this.leads = response.data;console.log(response)})
          .catch(response => console.log(response))
          .finally(() =>  this.loading = false)
    },

    buscar(){
     
          this.loading = true;
          let fm = null;

          
            fm = new FormData(this.$refs["formulario"]);
            fm.append('valor',this.filtrar(this.valor));
            fm.append('valor2',this.filtrar(this.valor2));
            fm.append('permissao',this.getPermissao());
            fm.append('corretor',this.getUsuario());
             fm.append('corretorBusca',this.corretor);
             fm.append('bairro',this.selectedBairro);
             fm.append('edificio',this.selectedEdificio);
             fm.append('paginacao',0);
             if(this.ocultar){
                fm.append('ocultar','Sim');
             }else{
                fm.append('ocultar','Nao');
             }
           
              

            if(this.selectedDate.length > 0){
              let dd = Number(this.selectedDate[0].getDate());
              let mm = Number(this.selectedDate[0].getMonth() + 1);
              if (dd < 10) dd = '0' + dd;
              if (mm < 10) mm = '0' + mm;
              let de = this.selectedDate[0].getFullYear() + "-" + mm + "-" + dd + " 00:00";

              let dd2 = Number(this.selectedDate[1].getDate());
              let mm2 = Number(this.selectedDate[1].getMonth() + 1);
              if (dd2 < 10) dd2 = '0' + dd2;
              if (mm2 < 10) mm2 = '0' + mm2;
              let ate = this.selectedDate[1].getFullYear() + "-" + mm2 + "-" + dd2 + " 23:59";

               fm.append('de',de);
               fm.append('ate',ate);
            }

        
          axios
          .post('https://www2.royaljardim.com.br/sistema/leads/buscaleads',fm)
          .then( response => {console.log(response);this.leads = response.data;this.copiarTelefone(response.data);})
          .catch(response => console.log(response))
          .finally(() =>  {this.loading = false;})
          
          
         
    },

   
     filtrar(dinheiro){
      return dinheiro.replace('R$', "").replace('.', "").replace('.', "").replace(',', ".");
    },
    getUsuario(){
       return sessionStorage.getItem('imobiliariaNome');
     },
     getPermissao(){
       return sessionStorage.getItem('imobiliaria');
     }

},
  
  mounted() {
    this.getUsuarios();
    this.get();
     
  }



}
</script>